import React from "react";
import { OrderHistory, HistoryColumn } from "../OrderHistory/OrderHistory";
import { TransferOrderApi } from "../../../api/TransferOrder/TransferOrderApi";
import {
  TransferOrderHistoryEntry,
  TransferOrderPartHistoryEntry,
} from "../../../@types/DRO/TransferOrderResponse";

const orderColumns: HistoryColumn<TransferOrderHistoryEntry>[] = [
  { key: "status", label: "Status" },
  {
    key: "amount",
    label: "Amount",
    render: (row) => `₹ ${row.amount?.toFixed(2) ?? "0.00"}`,
  },
  { key: "remark", label: "Remark" },
  { key: "action", label: "Action" },
  { key: "updatedBy", label: "Updated By" },
  { key: "updatedAt", label: "Updated At" },
];

const partColumns: HistoryColumn<TransferOrderPartHistoryEntry>[] = [
  { key: "partName", label: "Part Name" },
  { key: "action", label: "Action" },
  { key: "quantityOrdered", label: "Qty Ordered" },
  { key: "quantityReceived", label: "Qty Received" },
  { key: "quantityReturned", label: "Qty Returned" },
  {
    key: "price",
    label: "Price",
    render: (row) => `₹ ${row.price?.toFixed(2) ?? "0.00"}`,
  },
  {
    key: "total",
    label: "Total",
    render: (row) => `₹ ${row.total?.toFixed(2) ?? "0.00"}`,
  },
  { key: "updatedBy", label: "Updated By" },
  { key: "updatedAt", label: "Updated At" },
];

interface Props {
  transferOrderId: number;
  variant?: "inline" | "dialog";
  open?: boolean;
  onClose?: () => void;
}

export const TransferOrderHistory: React.FC<Props> = ({
  transferOrderId,
  variant = "inline",
  open = false,
  onClose,
}) => (
  <OrderHistory
    title="Transfer Order History"
    variant={variant}
    open={open}
    onClose={onClose}
    orderColumns={orderColumns}
    partColumns={partColumns}
    fetchHistory={async () => {
      const res = await TransferOrderApi.api.getTransferOrderHistory(
        transferOrderId
      );
      return {
        orderHistory: res.data.transferOrderHistory,
        partHistory: res.data.partHistory,
      };
    }}
  />
);